import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EmpSuccess from "../employees/employeeSuccess";
import {
  createNewSuperDistributor,
  updateSuperDistributor,
} from "../../../apis/distributors";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import {
  getAllNationals,
  getAllNationalsSuper_Distributor,
} from "../../../apis/nationals";
import { errorAlert, successAlert } from "../../../style/scss/utils/Alerts";
import { ChangeStatus, uploadFile } from "../../../apis/auth";
import CommonSearch from "../commonSearch";
import { Moment } from "moment";
import Newloader from "../employees/loader";
import { formatDate } from "../../../environment";

type PasswordField = "password" | "confirmPassword";

const SuperDistributorList = () => {
  const initialValues = {
    full_name: "",
    user_name: "",
    email: "",
    password: "",
    confirm_password: "",
    phone_number: "",
    company: "",
    prefix_code: "",
    about: "",
    geo_location: "",
    gst_no: "",
    company_name: "",
  };
  const addressState = {
    addressLine: "",
    city: "",
    states: "",
    country: "",
    pincode: "",
  };
  const [address, setAddress] = useState(addressState);
  const { city, states, country, pincode, addressLine } = address;
  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [filteredData, setFilteredData] = useState<EmployeeData[]>([]);
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const [image, setImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [selectedmaster, setSelectedMaster] = useState<any>();
  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({ start: undefined, end: undefined });
  const { start, end } = state;

  const handleSelectNat = (item: any) => {
    setSelectedMaster(item);
    getAllNational();
  };
  const optionNat = [{ value: "national", label: "National" }];

  const {
    full_name,
    user_name,
    email,
    password,
    confirm_password,
    phone_number,
    company_name,
    gst_no,
  } = formData;

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }
      setError("");
      setImage(file);
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setImageUrl(response.data.image);
      }
    }
  };

  const handleCancel = () => {
    setImage(null);
    setError("");
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleAddressChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setAddress({ ...address, [name]: value });
  };
  type EmployeeResponse = {
    full_name: string;
    national_id: number;
    adress: string;
    geo_location: string;
    Image: string;
    email: string;
    phone_number: string;
    profile_pic: string;
    createdAt: string;
    Status: string;
    address: string;
    id: any;
    company_name: string;
  };

  type EmployeeData = {
    key: string;
    Name: string;
    Image: string;
    Email: string;
    geo_location: string;
    Phone: string;
    address: string;
    Status: string;
    national_id: string;
    id: any;
    allDetails: any;
    company_name: string;
  };
  const [loader, setLoader] = useState(false);
  const fetchAllEmployees = async () => {
    setLoader(true);
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
      };
      const response = await getAllNationalsSuper_Distributor(data);
      const employeeData = response?.data?.superDistributorData?.map(
        (item: EmployeeResponse, i: number) => ({
          key: `${i + 1}`,
          CreatedAt: formatDate(item.createdAt),
          company_name: item.company_name,
          Name: `${item.full_name}`,
          address: (() => {
            try {
              const parsed = JSON.parse(item.address);
              return `${parsed.addressLine || ""}, ${parsed.city || ""}, ${parsed.states || ""
                }, ${parsed.country || ""} - ${parsed.pincode || ""}`;
            } catch {
              return "--";
            }
          })(),
          Email: item?.email || "--",
          Phone: item?.phone_number || "--",
          Image: item.profile_pic ? item.profile_pic : "--",
          Status: item?.Status || "--",
          national_id: item?.national_id || "--",
          id: item?.id || "--",
          allDetails: item,
        })
      );
      setEmployeeData(employeeData || []);
      setFilteredData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false);
    }
  };
  const [department, setDepartment] = useState<any>([]);
  interface National {
    id: string;
    full_name: string;
  }
  const getAllNational = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationals(data);
    setDepartment(
      response.data.map((ele: National) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };
  useEffect(() => {
    fetchAllEmployees();
  }, [state]);
  const [newStatus, setNewStatus] = useState<any>(null);
  const handleChangeStatus = (data: { id: string; status: string }) => {
    const payload = {
      id: data.id,
      status: data.status,
    };
    setNewStatus(payload);
  };

  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
      render: (text: string) => <div>{text}</div>,
      sorter: (a: EmployeeData, b: EmployeeData) => a.key.localeCompare(b.key),
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (_: any, record: EmployeeData) => (
        <div>{formatDate(record?.allDetails?.createdAt) || "--"}</div>
      ),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.Name}</p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      render: (text: string) => text,
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Email.localeCompare(b.Email),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Parent Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{record?.allDetails?.national?.company_name || "N/A"}</div>
          </p>
        </div>
      ),
    },
    {
      title: "Owner Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{"National"}</div>
          </p>
        </div>
      ),
    },

    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: EmployeeData) => (
        <span className="dropdown">
          <Link
            to="#"
            className={`badge  btn btn-white ${text === "Active" ? "badge-success" : "badge-danger"
              } d-inline-flex align-items-center badge-xs`}
            data-bs-toggle="dropdown"
          >
            <i className="ti ti-point-filled me-1" />
            {record?.allDetails?.user?.status}
          </Link>
          <ul className="dropdown-menu dropdown-menu-end p-3">
            <li>
              <div
                className="dropdown-item rounded-1"
                data-bs-toggle="modal"
                data-bs-target="#status_modal"
                onClick={() =>
                  handleChangeStatus({
                    id: record?.allDetails?.user_id,
                    status: "Active",
                  })
                }
              >
                Active
              </div>
            </li>
            <li>
              <div
                className="dropdown-item rounded-1"
                data-bs-toggle="modal"
                data-bs-target="#status_modal"
                onClick={() =>
                  handleChangeStatus({
                    id: record.allDetails.user_id,
                    status: "InActive",
                  })
                }
              >
                InActive
              </div>
            </li>
          </ul>
        </span>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Status.localeCompare(b.Status),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: EmployeeData) => (
        <div className="action-icon d-inline-flex">
          <div
            style={{ cursor: "pointer" }}
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#login_modal"
            onClick={() => login(record)}
          >
            <i className="fas fa-sign-in-alt" />
          </div>
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#add_employee"
            onClick={() => handleEdit(record.allDetails)}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to={`/superdistributor?super_distributor_id=${encodeURIComponent(
              JSON.stringify(record.id)
            )}`}
          >
            <i className="ti ti-eye" />
          </Link>
        </div>
      ),
    },
  ];
  const [recordData, SetRecordData] = useState<any>();

  const [edit, setEdit] = useState(false);
  const [id, setId] = useState();
  const handleEdit = (data: any) => {
    setEdit(true);
    setId(data?.id);
    const parsedAddress = JSON.parse(data.address || {});
    setFormData((prevFormData) => ({
      ...prevFormData,
      full_name: data?.full_name,
      email: data?.email,
      phone_number: data?.phone_number,
      gst_no: data?.gst_number,
      company_name: data?.company_name,
    }));
    setAddress({
      addressLine: parsedAddress?.addressLine,
      city: parsedAddress?.city,
      states: parsedAddress?.states,
      country: parsedAddress?.country,
      pincode: parsedAddress?.pincode,
    });
  };

  const [selectedOption, setSelectedOption] = useState<any>();
  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
    const newResponse = allEmployeeData.filter((ele, i) => {
      return Number(ele.national_id) === Number(option?.value);
    });
    setFilteredData(newResponse);
  };

  const login = (data: any) => {
    SetRecordData(data);
  };
  const handleSubmitLogin = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const loginData = sessionStorage.getItem("info");
    if (loginData) {
      localStorage.setItem("info", loginData);
      let change = "change";
      sessionStorage.setItem("changing", change);
    }
    const payload = {
      id: recordData?.allDetails?.id,
      type: recordData?.allDetails?.type,
      user_id: recordData?.allDetails?.user_id,
      username: recordData?.allDetails?.full_name,
    };
    sessionStorage.setItem("info", JSON.stringify(payload));
    window.location.href = "/index";
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const mtIdString = sessionStorage.getItem("info");
  let mtId: { id: string; user_id: string } | null = null;

  if (mtIdString) {
    try {
      mtId = JSON.parse(mtIdString);
    } catch (error) {
      console.error("Failed to parse sessionStorage info:", error);
    }
  }
  if (mtId && mtId.id) {
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (password !== confirm_password) {
      errorAlert("password and confirm_password should be the same");
      return;
    }
    const requiredFields = [
      "email",
      "full_name",
      "password",
      "phone_number",
      "user_name",
    ];
    const editRequiredFields = ["email", "full_name", "phone_number"];
    const editedFields = edit ? editRequiredFields : requiredFields;
    const emptyFields = editedFields.filter(
      (field) => !formData[field as keyof typeof formData]?.trim()
    );

    if (emptyFields.length > 0) {
      console.error(
        `The following fields are empty: ${emptyFields.join(", ")}`
      );
      errorAlert(
        `Please fill out the required fields: ${emptyFields.join(", ")}`
      );
      return; // Stop execution if any field is empty
    }
    setLoader(true);
    const master_Id = mtId?.id || "0";

    const payload = {
      address: address,
      email: formData.email,
      gst_number: formData.gst_no,
      company_name: formData.company_name,
      prefix_code: formData.company_name,
      full_name: formData.full_name,
      password: formData.password,
      phone_number: formData.phone_number,
      user_name: formData.user_name,
      geo_location: formData.geo_location,
      profile_pic: imageUrl,
      national_id: master_Id,
      type: "super_distributer",
    };

    try {
      if (!edit) {
        const response = await createNewSuperDistributor(payload);
        // const response = await updateSuperDistributor(id,payload);
        if (response.status === true) {
          successAlert("Success", "Successfully created");
          fetchAllEmployees();
          setSuccessCreation(true);
          setImage(null);
          setFormData(initialValues);
          setAddress(addressState);
        }
      } else {
        const payloads = {
          address: address,
          email: formData.email,
          gst_number: formData.gst_no,
          company_name: formData.company_name,
          full_name: formData.full_name,
          phone_number: formData.phone_number,
          profile_pic: imageUrl,
        };

        const response = await updateSuperDistributor(id, payloads);
        if (response.status === true) {
          successAlert("Success", "Successfully updated");
          fetchAllEmployees();
          setSuccessCreation(true);
          setImage(null);
          setEdit(false);
          setId(null);
          setFormData(initialValues);
          setAddress(addressState);
        }
      }
    } catch (error) {
      errorAlert("error", `${error?.response?.data?.message}`);
    } finally {
      setLoader(false);
    }
    // action={all_routes.employeeList}
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "super-distributor");
    XLSX.writeFile(workbook, "Super Distributor List.xlsx");
  };

  const handleSubmitStatus = async (event: any) => {
    event.preventDefault();
    try {
      const payload = {
        status: newStatus?.status,
      };
      const response = await ChangeStatus(newStatus?.id, payload);
      if (response.status === true) {
        successAlert("success", `User Status Changed to ${newStatus?.status}`);
        fetchAllEmployees();
        setNewStatus(null);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>

              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_employee"
                  className="btn btn-primary d-flex align-items-center"
                  onClick={() => {
                    setEdit(false);
                    setFormData(initialValues);
                    setAddress(addressState);
                    setImage(null);
                  }}
                >
                  <i className="ti ti-circle-plus me-2" />
                  Create New Super Disributor
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <CommonSearch
                    allEmployeeData={allEmployeeData}
                    setFilteredData={setFilteredData}
                  />
                </div>
                {/* <div> */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent Role</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selectedmaster ? selectedmaster.label : "Select Role"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {optionNat.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleSelectNat(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent User</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selectedOption ? selectedOption.label : "Select User"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {department.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {loader ? (
              <div className="card-body p-0">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    height: "30vh",
                    alignItems: "center",
                  }}
                >
                  <Newloader />
                </div>
              </div>
            ) : (
              <div className="card-body p-0">
                {filteredData && filteredData.length > 0 ? (
                  <Table
                    dataSource={filteredData}
                    columns={columns}
                    Selection={true}
                  // rowSelection={{ type: "checkbox" }}
                  />
                ) : (
                  <div>
                    <p
                      className="custom-cal-react "
                      style={{ padding: "15px" }}
                    >
                      No Data Found
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {/* <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2026 © Paybia Finance.</p>
          <p>
            Designed &amp; Developed By{" "}
            <Link to="#" className="text-primary">
              Anjani Creations
            </Link>
          </p>
        </div> */}
      </div>
      {/* /Page Wrapper */}
      {/* Add Employee */}

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Super Distributor</h4>
                {/* <span>Super-Distributor ID : EMP -0024</span> */}
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                  <li className="nav-item" role="presentation"></li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                            <i className="ti ti-photo text-gray-2 fs-16" />
                          </div>
                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Upload Profile Image</h6>
                              <p className="fs-12">
                                Image should be below 4 MB
                              </p>
                              {error && <p className="text-danger">{error}</p>}
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                {image ? "Replace" : "Upload"}
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                />
                              </div>
                              <Link
                                to="#"
                                className="btn btn-light btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </Link>
                            </div>
                            {image && (
                              <div className="mt-3">
                                <p>Preview:</p>
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt="Profile Preview"
                                  className="img-thumbnail"
                                  style={{
                                    maxWidth: "150px",
                                    maxHeight: "150px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            First Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="full_name"
                            value={full_name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            required
                            name="email"
                            value={email}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            required
                            name="phone_number"
                            value={phone_number}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      {/* <div className="col-md-6">
  <div className="mb-3">
    <label className="form-label">
      Prefix Code <span className="text-danger"> *</span>
    </label>
    <input
      type="text"
      required
      name="prefix_code"
      value={prefix_code}
      onChange={handleChange}
      className="form-control"
    />
  </div>
</div> */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Company Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="company_name"
                            value={company_name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {!edit && (
                        <>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                user_name{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                required
                                name="user_name"
                                value={user_name}
                                onChange={handleChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3 ">
                              <label className="form-label">
                                Password <span className="text-danger"> *</span>
                              </label>
                              <div className="pass-group">
                                <input
                                  type={
                                    passwordVisibility.password
                                      ? "text"
                                      : "password"
                                  }
                                  className="pass-input form-control"
                                  name="password"
                                  value={password}
                                  onChange={handleChange}
                                  required
                                />
                                <span
                                  className={`ti toggle-passwords ${passwordVisibility.password
                                      ? "ti-eye"
                                      : "ti-eye-off"
                                    }`}
                                  onClick={() =>
                                    togglePasswordVisibility("password")
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3 ">
                              <label className="form-label">
                                Confirm Password{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <div className="pass-group">
                                <input
                                  type={
                                    passwordVisibility.confirmPassword
                                      ? "text"
                                      : "password"
                                  }
                                  className="pass-input form-control"
                                  name="confirm_password"
                                  value={confirm_password}
                                  onChange={handleChange}
                                  required
                                />
                                <span
                                  className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                      ? "ti-eye"
                                      : "ti-eye-off"
                                    }`}
                                  onClick={() =>
                                    togglePasswordVisibility("confirmPassword")
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Gst No <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="gst_no"
                            value={gst_no}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Address Line <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="addressLine"
                            value={addressLine}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            City <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="city"
                            value={city}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            State <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="states"
                            value={states}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Country <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="country"
                            value={country}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            PinCode <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="pincode"
                            value={pincode}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      {/* <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Geo Location<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="geo_location"
                            value={geo_location}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      // onClick={handleSubmit}
                      // data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="address"
                  role="tabpanel"
                  aria-labelledby="address-tab"
                  tabIndex={0}
                >
                  <div className="modal-body">
                    <div className="card bg-light-500 shadow-none">
                      <div className="card-body d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h6>Enable Options</h6>
                        <div className="d-flex align-items-center justify-content-end">
                          <div className="form-check form-switch me-2">
                            <label className="form-check-label mt-0">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                                role="switch"
                              />
                              Enable all Module
                            </label>
                          </div>
                          <div className="form-check d-flex align-items-center">
                            <label className="form-check-label mt-0">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultChecked
                              />
                              Select All
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive border rounded"></div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-inert={true}
                      data-bs-target="#success_modal"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* /Add Employee */}
      {/* Edit Employee */}

      <div className="modal fade" id="login_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Login</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitLogin}>
              <div
                className="contact-grids-tab"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <h3>Are you sure? you want to login</h3>
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Login{" "}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="status_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Change Status</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitStatus}>
              <div
                className="contact-grids-tab"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <h3>Are you sure? you want to {newStatus?.status} this user</h3>
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default SuperDistributorList;
